/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Users_Invite_HintInputs */

const cs_settings_users_invite_hint = /** @type {(inputs: Settings_Users_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odkaz zkopírujte a pošlete uživateli. Heslo si nastaví sám.`)
};

const en_settings_users_invite_hint = /** @type {(inputs: Settings_Users_Invite_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy this link and send it to the user. They will set their own password.`)
};

/**
* | output |
* | --- |
* | "Copy this link and send it to the user. They will set their own password." |
*
* @param {Settings_Users_Invite_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_users_invite_hint = /** @type {((inputs?: Settings_Users_Invite_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Users_Invite_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_users_invite_hint(inputs)
	return cs_settings_users_invite_hint(inputs)
});